'use client';
import React, { useState, ReactNode } from 'react';
import { ExpandMoreIcon } from '../icons';
import styles from './LightAccordion.module.css';

interface LightAccordionProps {
  title: ReactNode;
  children: ReactNode;
  defaultExpanded?: boolean;
  id?: string;
  lazy?: boolean;
}

const LightAccordion: React.FC<LightAccordionProps> = ({
  title,
  children,
  defaultExpanded = false,
  id = 'light-accordion',
  lazy = false
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const [hasBeenOpened, setHasBeenOpened] = useState(defaultExpanded);

  return (
    <div className={`${styles.accordion}${expanded ? ` ${styles.expanded}` : ''}`}>
      <div
        className={styles.summary}
        onClick={() => {
          if (!hasBeenOpened) setHasBeenOpened(true);
          setExpanded(!expanded);
        }}
        role="button"
        aria-controls={`${id}-content`}
        aria-expanded={expanded}
        id={`${id}-header`}
      >
        <div className={styles.summaryContent}>{title}</div>
        <ExpandMoreIcon
          fontSize="medium"
          className={`${styles.expandIcon}${expanded ? ` ${styles.rotated}` : ''}`}
        />
      </div>
      <div
        id={`${id}-content`}
        className={expanded ? styles.details : styles.detailsCollapsed}
        role="region"
        aria-labelledby={`${id}-header`}
      >
        {(!lazy || hasBeenOpened) && children}
      </div>
    </div>
  );
};

export default LightAccordion;
